import { defineStore } from 'pinia'
import { store } from '@/store'
import { isEmpty, isWxMiniProgram } from '@/utils/is'
import useApi from '@/api/live'
import { useRouter } from 'vue-router'
import { useGlobalLoading } from '@/hooks/useGlobalLoading.ts'
import { useProductBackStore } from '@/store/modules/productBack'
import { useWatchStore } from '@/store/modules/watch'

const router = useRouter()
const { closeGlobalLoading } = useGlobalLoading()
// 当前项目全局配置缓存
export const useAppStore = defineStore('app', {
  state: () => {
    return {
      currentProduct: {},
      order: {},
      config: {
        clientId: null, // 客户ID
        playbackVideoUrl: '', // 回放视频地址 | 新主播端为横屏视频地址
        mixPlaybackVideoUrl: '', // 混流回放视频地址 | 新主播端为竖屏视频地址
        enablePlayback: null, // 是否开启回放 1: 开启, 0: 未开启
        playbackVideoType: null, // 回放视频类型，1-录播 2-媒体库
        playbackMode: null, // 回放模式，1-播放最后一次直播视频 2-选择视频
        playbackVideoCode: null, // 回放视频ID
        enableCountdown: null, // 是否开启倒计时 1 = 开启, 0 = 未开启
        authType: null, // 用户观看类型 0-无限制 1-密码登录 2-手机验证观看 3-微信授权观看 4-参数验证观看 5-报名观看
        allowVisitorLogin: null, // 是否允许游客登录, 1: 允许, 0: 不允许
        showWxNickname: null, // 手机验证观看-用户是否使用微信昵称 1-使用 0-不使用
        mobileThemeType: null, // 手机模板，手机端观看模板 1-全屏 2-二分屏 3-三分屏 (新增)
        enableMessagePlayback: null, // 是否开启消息回放 1: 开启, 0: 未开启
        resourceUrl: '', // 资源路径
        fontColor: '', // 文字颜色
        fontSize: '', // 文字大小
        fontTransparency: null, // 文字透明度
        title: '', // 直播间名称
        shareDescription: '', // 分享描述
        shareIcon: '', // 分享图标
        thirdAuthUrl: '', // 第三方验证url(失败跳转url)
        mobileFullScreenThemeType: null, // 手机全屏模板类型 1-丰富 2-简洁
        userNicknameMarqueeContent: '', // 用户昵称跑马灯内容
        liveRoomNameMarqueeContent: '', // 直播间名称跑马灯内容
        userTimes: null, // 实时观看人数倍数
        onlineUserCount: null, // 显示人数
        auditMessage: null, // 消息审核开关 0关闭 1开启
        sensitiveWordFilter: null, // 是否开启敏感词过滤，0-否 1-是
        supportWhitePassword: null, // 1-支持输入白名单密码观看
        watchDomainProtocol: '', // 观看域名协议
        watchDomain: '', // 观看端域名
        wxAuthDomain: '', // 授权域名
        recordProductMsg: null // 是否开启商品回放 1: 开启, 0: 未开启
      },
      giftList: [],
      commodityList: [],
      commodityConfig: {}, // 商品配置
      recommend: { show: false },
      recommendStatus: false,
      realPeople: 0, // 实时观看人数
      auditWords: [],
      sensiWords: [],
      canReload: true,
      handStatus: false,
      seriesConfig: {},
      canUseCouponList: [], // 可使用的优惠券列表
      userGetCouponList: [], // 用户已领取的优惠券列表
      couponConfig: {}, // 优惠券配置
      redConfig: {}, // 红包配置配置
      redBagDialog: { show: false },
      isLogout: false, // 是否已经退出
      storageAction: false,
      storageYHJAction: false,
      storageCouponIsShow: false,
      scekillInfoNews: {}, // 秒杀商品信息
      prizeDrawConfig: {}, // 房间抽奖配置
      // 微信配置
      wxConfig: {
        appId: '',
        componentAppId: ''
      },
      playRandom: 0, // 随机数，微信支付成功、失败、取消后都会变动，播放器监听后触发play
      // 展示的公告消息列表
      displayNoticeMsgList: [],
      isReportEnterRoom: false, // 是否完成进入房间上报
      visibilityStatus: 'visible', // 页面状态：visible-页面显示、hidden-页面隐藏
      noticeTopInfo: null, // 置顶公告信息
      landscapeStatus: 0, // 横竖屏状态, 0-竖屏、1-横屏
      liveStatus: 0, // 直播状态， 0-未开始、1-直播中
    }
  },
  getters: {
    getSensiWords(): any {
      return this.sensiWords
    },
    getAuditWords(): any {
      return this.auditWords
    },
    getRealPeople(): any {
      return this.realPeople
    },
    getConfig(): any {
      return this.config
    },
    getGift(): any {
      return this.giftList
    },
    getCommodity(): any {
      return this.commodityList
    },
    getRecommend(): any {
      return this.recommend
    },
    getRecommendStatus(): any {
      return this.recommendStatus
    },
    getCommodityConfig(): any {
      return this.commodityConfig
    },
    getOrder(): any {
      return this.order
    },
    getCurrentProduct(): any {
      return this.currentProduct
    },
    getCanReload(): any {
      return this.canReload
    },
    getHandStatus(): any {
      return this.handStatus
    },
    getSeriesConfig(): any {
      return this.seriesConfig
    },
    getCanUseCouponList(): any {
      return this.canUseCouponList
    },
    getCouponConfig(): any {
      return this.couponConfig
    },
    getUserGetCouponList(): any {
      return this.userGetCouponList
    },
    getRedConfig(): any {
      return this.redConfig
    },
    getIsLogout(): any {
      return this.isLogout
    },
    getScekillInfo(): any {
      return this.scekillInfoNews
    },
    getPrizeDrawConfig(): any {
      return this.prizeDrawConfig
    }
  },
  actions: {
    /** 设置页面状态 */
    setVisibilityStatus(val: string) {
      this.visibilityStatus = val
    },
    /** 设置随机数 */
    setPlayRandom() {
      this.playRandom = Math.floor(Math.random() * 100) + 1
    },
    /** 设置房间抽奖配置 */
    setPrizeDrawConfig(config: any) {
      this.prizeDrawConfig = config
    },
    setRelPeople(val: any) {
      this.realPeople = val
    },
    setConfig(config: any) {
      this.config = config
      if (config.recordProductMsg && useWatchStore().playbackStatus) {
        useProductBackStore().setProductBackMessage()
      } else {
        useProductBackStore().resetProductBackMessage()
      }
    },
    setGiftList(list: any) {
      this.giftList = list
    },
    setCommodityList(list: any) {
      this.commodityList = list
    },
    setRecommendStatus(val: any) {
      this.recommendStatus = val
      console.log('sssssss1', val)
    },
    setRecommend(val: object) {
      this.recommend = !isEmpty(val) && val ? { show: true, ...val } : { show: false }
      console.log('sssssss', this.recommend)
    },
    setCommodityConfig(val: any) {
      this.commodityConfig = val
    },
    setOrder(order: any) {
      this.order = order
    },
    setCurrentProduct(currentProduct: any) {
      this.currentProduct = currentProduct
    },
    setSensiWords(val: any) {
      this.sensiWords = val
    },
    setAuditWords(val: any) {
      this.auditWords = val
    },
    setCanReload(val: any) {
      this.canReload = val
    },
    setHandStatus(val: any) {
      this.handStatus = val
    },
    setSeriesConfig(val: any): any {
      this.seriesConfig = val
    },
    setCanUseCouponList(val: any) {
      this.canUseCouponList = val
    },
    setCouponConfig(val: any) {
      this.couponConfig = val
    },
    setUserGetCouponList(val: any) {
      this.userGetCouponList = val
    },
    setRedConfig(val: any) {
      this.redConfig = val
    },
    setIsLogout(val: any) {
      this.isLogout = val
    },
    setStorageAction(newMessage: any) {
      this.storageAction = newMessage
    },
    setStorageYHJAction(newMessage: any) {
      this.storageYHJAction = newMessage
    },
    setStorageCouponIsShow(newMessage: any) {
      this.storageCouponIsShow = newMessage
    },
    setSeckillInfo(val: any) {
      this.scekillInfoNews = val
    },
    // 获取房间配置
    async fetchRoomConfig(roomId: string) {
      const res = await useApi.getRoomConfig({ roomId: roomId, miniType: isWxMiniProgram() ? 1 : 0 })
      if (res.code !== 200) {
        closeGlobalLoading()
        if (res.code === 400) {
          return '1'
        }
        return '9'
      }

      const data = res.data
      if (data?.playbackVideoStreamType === 1) {
        if (data?.playbackVideoPushStreamType === 2) {
          data.playbackVideoUrl = data?.mixPlaybackVideoUrl
        } else if (data?.playbackVideoPushStreamType === 3) {
          if (data?.mobileThemeType === 1) {
            data.playbackVideoUrl = data?.mixPlaybackVideoUrl
          }
        }
      }
      this.config = data
    },
    /** 设置直播状态 */
    setLiveStatus(val: number) {
      this.liveStatus = val
    },
  }
})

export const useAppStoreWithOut = () => {
  return useAppStore(store)
}
